import axios from 'axios';

import { axiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';
import { customerId } from 'common/helpers/tokenHelper';

export const getCustomerLoyaltySummary = () =>
  axios.get(
    `${getV2RootUrl()}/customer/${customerId()}/loyalty/summary`,
    axiosHeaderV2()
  );
